export default "/assets/deee08c3b7156b99.png"